import { useMemo } from "react";

import { IntlShape } from "react-intl";

import BaseMapStyle from "@mapmycustomers/shared/enum/map/BaseMapStyle";

import googleMapStyles from "@app/component/map/googleMapStyles";
import { getBaseMapStyleDisplayName } from "@app/util/ui";

const useBasemapStyleOptions = (
  intl: IntlShape,
  styles: BaseMapStyle[] = Object.keys(googleMapStyles) as BaseMapStyle[]
) =>
  useMemo(
    () =>
      styles.map((name) => ({
        label: intl.formatMessage(
          {
            id: "simpleEntityMap.layer.label",
            defaultMessage: "Basemap: {name}",
            description: "Layer name on the generic entity map",
          },
          { name: getBaseMapStyleDisplayName(intl, name) }
        ),
        value: name,
      })),
    [intl, styles]
  );

export default useBasemapStyleOptions;
